export enum ContactWarningPreference {
  SHOW = "SHOW",
  SUPPRESSED = "SUPPRESSED",
}
